export default __webpack_public_path__ + "static/media/Tapt Design Template.720c0ba1.pdf";